var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "onboarding-step" },
    [
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ invalid, dirty, handleSubmit }) {
              return [
                _c(
                  "form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.submit)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "onboarding-block-wrap" }, [
                      _c("h4", { staticClass: "onboarding-step-heading" }, [
                        _vm._v(" Personal information "),
                      ]),
                      _c("div", { staticClass: "onboarding-fields-wrap" }, [
                        _c(
                          "div",
                          { staticClass: "onboarding-field-item" },
                          [
                            _c("ValidationProvider", {
                              attrs: {
                                name: "form.firstname",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors, touched }) {
                                      return [
                                        _c("NewFormGroup", {
                                          attrs: {
                                            id: "form.firstname",
                                            name: "form.firstName",
                                            type: "text",
                                            placeholder: "",
                                            errors:
                                              touched && errors.length > 0
                                                ? ["First Name is required"]
                                                : [],
                                            allowOnlyAlphanumeric: true,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "title",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "text-sm text-gray-90 ml-1",
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "font-semibold",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "onboarding-required-icon",
                                                              },
                                                              [_vm._v("*")]
                                                            ),
                                                            _vm._v(
                                                              " First Name : "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: _vm.form.firstName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "firstName",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "form.firstName",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "onboarding-field-item" },
                          [
                            _c("ValidationProvider", {
                              attrs: {
                                name: "form.lastName",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors, touched }) {
                                      return [
                                        _c("NewFormGroup", {
                                          attrs: {
                                            id: "form.lastName",
                                            name: "form.lastName",
                                            type: "text",
                                            placeholder: "",
                                            errors:
                                              touched && errors.length > 0
                                                ? ["Last Name is required"]
                                                : [],
                                            allowOnlyAlphanumeric: true,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "title",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "text-sm text-gray-90 ml-1",
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "font-semibold",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "onboarding-required-icon",
                                                              },
                                                              [_vm._v("*")]
                                                            ),
                                                            _vm._v(
                                                              " Last Name : "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: _vm.form.lastName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "lastName",
                                                $$v
                                              )
                                            },
                                            expression: "form.lastName",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "onboarding-field-item" },
                        [
                          _c("ValidationProvider", {
                            attrs: {
                              name: "form.email",
                              rules: "c_email|required",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors, touched }) {
                                    return [
                                      _c("FormGroup", {
                                        attrs: {
                                          id: "form.email",
                                          name: "form.email",
                                          type: "email",
                                          placeholder: "",
                                          errors:
                                            touched && errors.length > 0
                                              ? ["Email is required"]
                                              : [],
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "title",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "text-sm text-gray-90 ml-1",
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "font-semibold",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "onboarding-required-icon",
                                                            },
                                                            [_vm._v("*")]
                                                          ),
                                                          _vm._v(" Email : "),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: _vm.form.email,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "email", $$v)
                                          },
                                          expression: "form.email",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "onboarding-field-item" },
                        [
                          _c("ValidationProvider", {
                            attrs: {
                              name: "form.phoneNumber",
                              rules: "required",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "FormGroup",
                                        {
                                          attrs: {
                                            id: "form.phoneNumber",
                                            name: "form.phoneNumber",
                                            errors:
                                              _vm.phoneTouched &&
                                              errors.length > 0
                                                ? ["Phone Number is required"]
                                                : [],
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "title",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "text-sm text-gray-90 ml-1",
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "font-semibold",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "onboarding-required-icon",
                                                              },
                                                              [_vm._v("*")]
                                                            ),
                                                            _vm._v(
                                                              " Phone Number : "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("MaskedPhoneInput", {
                                            attrs: {
                                              invalid: Boolean(
                                                _vm.phoneTouched &&
                                                  !!errors.length
                                              ),
                                            },
                                            on: {
                                              touched: () => {
                                                _vm.phoneHasErrors =
                                                  !!errors.length
                                                _vm.phoneTouched = true
                                              },
                                            },
                                            model: {
                                              value: _vm.form.phoneNumber,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "phoneNumber",
                                                  $$v
                                                )
                                              },
                                              expression: "form.phoneNumber",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "onboarding-block-wrap" }, [
                      _c("h4", { staticClass: "onboarding-step-heading" }, [
                        _vm._v(" Emergency contact information "),
                      ]),
                      _c("div", { staticClass: "onboarding-fields-wrap" }, [
                        _c(
                          "div",
                          { staticClass: "onboarding-field-item" },
                          [
                            _c("ValidationProvider", {
                              attrs: {
                                name: "form.emergencyContact.firstName",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors, touched }) {
                                      return [
                                        _c("NewFormGroup", {
                                          attrs: {
                                            id: "form.emergencyContact.firstName",
                                            name: "form.emergencyContact.firstName",
                                            type: "text",
                                            placeholder: "",
                                            errors: touched ? errors : [],
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "title",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "text-sm text-gray-90 ml-1",
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "font-semibold",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " First Name "
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "onboarding-optional-text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " (optional)"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value:
                                              _vm.form.emergencyContact
                                                .firstName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form.emergencyContact,
                                                "firstName",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression:
                                              "\n\t\t\t\t\t\t\t\t\tform.emergencyContact.firstName\n\t\t\t\t\t\t\t\t",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "onboarding-field-item" },
                          [
                            _c("ValidationProvider", {
                              attrs: { name: "form.emergencyContact.lastName" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors, touched }) {
                                      return [
                                        _c("NewFormGroup", {
                                          attrs: {
                                            id: "form.emergencyContact.lastName",
                                            name: "form.emergencyContact.lastName",
                                            type: "text",
                                            placeholder: "",
                                            errors: touched ? errors : [],
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "title",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "text-sm text-gray-90 ml-1",
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "font-semibold",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Last Name "
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "onboarding-optional-text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " (optional)"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value:
                                              _vm.form.emergencyContact
                                                .lastName,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form.emergencyContact,
                                                "lastName",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.emergencyContact.lastName",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "onboarding-field-item" },
                        [
                          _c(
                            "ValidationProvider",
                            {
                              attrs: {
                                name: "form.emergencyContact.phoneNumber",
                              },
                            },
                            [
                              _c(
                                "FormGroup",
                                {
                                  attrs: {
                                    id: "form.emergencyContact.phoneNumber",
                                    name: "form.emergencyContact.phoneNumber",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "title",
                                        fn: function () {
                                          return [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "text-sm text-gray-90 ml-1",
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "font-semibold",
                                                  },
                                                  [
                                                    _vm._v(" Phone Number "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "onboarding-optional-text",
                                                      },
                                                      [_vm._v(" (optional)")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value:
                                      _vm.form.emergencyContact.phoneNumber,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.emergencyContact,
                                        "phoneNumber",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.emergencyContact.phoneNumber",
                                  },
                                },
                                [
                                  _c("MaskedPhoneInput", {
                                    model: {
                                      value:
                                        _vm.form.emergencyContact.phoneNumber,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form.emergencyContact,
                                          "phoneNumber",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.emergencyContact.phoneNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "onboarding-sticky-btn-holder" },
                        [
                          _c(
                            "div",
                            { staticClass: "onboarding-sticky-btn-wrap" },
                            [
                              _c("UiButton", {
                                staticClass: "my-6 block w-full",
                                attrs: {
                                  variant: "black",
                                  buttonText: "Continue",
                                  type: "submit",
                                  fullWidth: "",
                                  disabled: invalid,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }